import React, { useContext, useEffect, useState, useRef } from 'react';
import { RadioGroup, Input, Checkbox } from '@progress/kendo-react-inputs';
import { Button } from '@progress/kendo-react-buttons';
import DeleteFormItem from '../../DeleteFormItem';
import PublishSwitch from '../publishSwitch';
import { LocalizationContext } from '../../../contexts';
import './index.scss';
import '../forms.scss';

export default function QuickLinks({ data, onUpdate, validator, settingsData = {}, ...rest }) {
  const emptyItem = useRef({ text: "", link: "", link_target: "_top", isOldSiteUrl: false, label: "" });
  const [compData, setCompData] = useState({});
  //const [validateMode, setValidateMode] = useState(false);
  const [localization] = useContext(LocalizationContext);
  const { labels } = localization;

  validator.current = () => {
    return true;
  };

  useEffect(() => {
    const defaultData = { data: [{ ...emptyItem.current }] };
    const startCompData = { ...defaultData, ...JSON.parse(JSON.stringify(data ? data : {})) };
    if (startCompData.data.length === 0) {
      startCompData.data = [{ ...emptyItem.current }];
    }
    setCompData(startCompData);
  }, [data]);

  const handleDeleteClick = (itemIdToDelete) => {
    const newCompData = { ...compData };
    if (newCompData.data.length > 1) {
      newCompData.data.splice(itemIdToDelete, 1);
    } else {
      newCompData.data = [{ ...emptyItem.current }]
    }
    setCompData(newCompData);
    onUpdate(newCompData);
  };

  const handleAddClick = () => {
    const newCompData = { ...compData };
    newCompData.data = [...compData.data, { ...emptyItem.current }]
    setCompData(newCompData);
  };

  const updateItem = (i, newData) => {
    const newCompData = { ...compData };
    newCompData.data[i] = { ...compData.data[i], ...newData };
    setCompData(newCompData);
    onUpdate(newCompData);
  }

  // const validateForm = () => {
  //   if (compData && compData.data && compData.data.length === 1 && JSON.stringify(compData.data[0]) === JSON.stringify(emptyItem.current)) {
  //     setValidateMode(false);
  //   } else {
  //     const formNotValid = compData.data.some(item => !item.text || !item.link);
  //     if (formNotValid) {
  //       setValidateMode(true);
  //       return false;
  //     }
  //   }
  //   return true;
  // }

  const canPublish = (item) => {
    if (!item.text || !item.link || !item.label) {
      return false;
    }
    return true;
  };

  const isNotOneEmptyItem = () => {
    return (compData.data.length !== 1 || JSON.stringify(compData.data[0]) !== JSON.stringify(emptyItem.current));
  }

  const showRequired = (item, requiredField) => {
    return (isNotOneEmptyItem() && !item[requiredField])
  }

  return (
    <React.Fragment>
      <div className="form-message">
        {labels.pagesManagement.forms.show_for_identified_only}
      </div>
      <div className="form-content">
        <div className="form-items">
          {compData.data?.map((item, i) => {
            return (
              <React.Fragment key={i}>
                <div className="form-item">
                  <div className="form-item__title">
                    {labels.pagesManagement.forms.item} {i + 1}
                    {isNotOneEmptyItem() && <DeleteFormItem itemIdToDelete={i} handleDeleteClick={handleDeleteClick} />}
                  </div>
                  <div className="form-field">
                    <label className="form-field__label mandatory">{labels.pagesManagement.forms.add_button_text}</label>
                    <Input name={'text'} value={item.text} onChange={({ value }) => updateItem(i, { text: value })}></Input>
                    {showRequired(item, 'text') && <div className="form-field__required">{labels.pagesManagement.forms.required}</div>}
                  </div>
                  <div className="form-field">
                    <label className="form-field__label mandatory">{labels.pagesManagement.forms.add_link}</label>
                    <Input name={'link'} value={item.link} onChange={({ value }) => updateItem(i, { link: value })}></Input>
                    <RadioGroup data={[
                      { label: labels.pagesManagement.forms.open_top, value: '_top' },
                      { label: `${labels.pagesManagement.forms.open_blank} (${labels.pagesManagement.forms.for_external_links})`, value: '_blank' }
                    ]}
                      layout='horizontal'
                      value={item['link_target']}
                      onChange={({ value }) => {
                        updateItem(i, { link_target: value });
                      }}
                    />
                    {showRequired(item, 'link') && <div className="form-field__required">{labels.pagesManagement.forms.required}</div>}
                  </div>
                  <div className="form-field">
                    <label className="form-field__label inline">{labels.pagesManagement.forms.link_type}</label>
                    <Checkbox label={labels.pagesManagement.forms.old_site}
                      layout='horizontal'
                      value={item.isOldSiteUrl}
                      checked={item.isOldSiteUrl}
                      onChange={(event) => {
                        updateItem(i, { isOldSiteUrl: event.value });
                      }}
                    />
                  </div>
                  <div className="form-field">
                    <label className="form-field__label inline">{labels.pagesManagement.forms.show_icon}</label>
                    <Checkbox label={labels.pagesManagement.forms.show}
                      layout='horizontal'
                      value={item.hasIcon}
                      checked={item.hasIcon}
                      onChange={(event) => {
                        updateItem(i, { hasIcon: event.value });
                      }}
                    />
                  </div>
                  <div className="form-field">
                    <label className="form-field__label mandatory">{labels.pagesManagement.forms.object_name}</label>
                    <Input name={'label'} value={item.label} onChange={({ value }) => updateItem(i, { label: value })}></Input>
                    {showRequired(item, 'label') && <div className="form-field__required">{labels.pagesManagement.forms.required}</div>}
                  </div>

                  <PublishSwitch isPublish={item?.isPublish} canPublish={canPublish(item)}
                    updateItem={(event) => updateItem(i, { isPublish: event.target.value })} />
                </div>
                {compData.data.length - 1 === i && <div className="form-add"><Button primary={true} disabled={compData.data.length < 6 ? false : true} onClick={handleAddClick}>{labels.pagesManagement.forms.add_item}</Button></div>}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </React.Fragment>
  );
};